import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/login");
        return;
      }
      const sessionId = decodeURIComponent(match[1]);
      try {
        await exchangeGoogleSession(sessionId);
        // remove hash and go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login?error=oauth");
      }
    };
    run();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300 flex items-center justify-center">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
          Authentification…
        </div>
        <div className="w-12 h-px bg-white mx-auto animate-pulse" />
      </div>
    </div>
  );
}
